export default "__VITE_ASSET__CLLvonTz__"